import React, { useState } from "react";
import BaseForm from "../../app/components/BaseForm";
import Input from "../../app/components/Input";

const AddPanel = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({ nome: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Novo Painel"
      submitButtonText="Adicionar"
      cancelButtonText="Cancelar"
      isValid={!!formData.nome}
    >
      <Input
        name="nome"
        label="Nome do Painel"
        value={formData.nome}
        onChange={handleChange}
        required
      />
    </BaseForm>
  );
};

export default AddPanel;
